var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgThumbUpOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.60547 20.3264H16.7051C17.4123 20.3264 18.0235 19.8324 18.1717 19.1409L19.863 11.2515C20.0632 10.3177 19.3514 9.43703 18.3963 9.43703H14.9832C14.4867 9.43703 14.0654 9.07276 13.9937 8.58147L13.5559 5.58218C13.4484 4.84524 12.8164 4.29883 12.0716 4.29883H10.8454C10.5693 4.29883 10.3454 4.52269 10.3454 4.79883V7.32959C10.3454 8.4409 9.73104 9.46117 8.74883 9.98106L7.60547 10.5863M7.60547 9.87671H4.60547C4.32933 9.87671 4.10547 10.1006 4.10547 10.3767V20.2009C4.10547 20.4771 4.32933 20.7009 4.60547 20.7009H7.60547V9.87671Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpOutline);
export default __webpack_public_path__ + "static/media/thumb-up-outline.5f584f778e09d7503a27a084e67352aa.svg";
export { ForwardRef as ReactComponent };